import { useEffect, useState } from "react";
import { CloseSquare } from "iconsax-react";
import Spinner from "../../spinners/Spinner";

export default function RequestCancellationConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
}) {
  const [reason, setReason] = useState("");
  const trimmedReason = reason.trim();

  if (!isOpen) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!trimmedReason || loading) return;
    onConfirm(trimmedReason);
  };

  const handleClose = () => {
    if (loading) return;
    setReason("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-[#11111180] flex items-center justify-center p-4">
      <div className="bg-white rounded-md w-full max-w-[460px] shadow-xl overflow-hidden">
        <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between gap-4">
          <div>
            <h2 className="text-[15px] font-medium select-none">
              Request cancellation?
            </h2>
            <p className="text-xs opacity-80 mt-1">
              Enter a reason for requesting this order cancellation.
            </p>
          </div>
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="h-fit disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <CloseSquare variant="Bold" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="py-5 px-5">
          <textarea
            className="w-full min-h-[120px] resize-none rounded-md border p-3 text-sm outline-none focus:border-primary disabled:opacity-70"
            placeholder="Reason for cancellation request"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            disabled={loading}
          />
          <div className="mt-5 flex justify-end gap-3">
            <button
              type="button"
              className="text-xs w-[90px] h-[40px] flex items-center justify-center bg-primary-light rounded-md py-2 px-2 hover:opacity-80 duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={handleClose}
              disabled={loading}
            >
              No
            </button>
            <button
              type="submit"
              className="text-xs w-[110px] h-[40px] flex items-center justify-center bg-[tomato] text-white rounded-md py-2 px-2 hover:opacity-80 duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
              disabled={!trimmedReason || loading}
            >
              {loading ? <Spinner color="white" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
